export default "__VITE_ASSET__MxhoXDbo__"